import { Routes, Route, Navigate } from 'react-router-dom';

import CarNavigation from './CarNavigation';
import CarMainData from './CarMainData';
import CarDocs from './CarDocs';
import CarDeal from './CarDeal';
import NewCarDocs from './NewCar/NewCarDocs';
import NewCarDeal from './NewCar/NewCarDeal';
import CarCreate from './NewCar/CarCreate';
import CarContainers from './Containers/CarContainers';
import CarComplectationsCreate from './Complectations/CarComplectationsCreate';
import CarContainersCreate from './Containers/CarContainersCreate';
import CarMarks from './Marks/CarMarks';
import CarModels from './Marks/CarModels';
import CarMarksCreate from './Marks/CarMarksCreate';
import CarComplectations from './Complectations/CarCompectations';
import CarModelsCreate from './Marks/CarModelsCreate';
import CarOptions from './Options/CarOptions';
import CarOptionsCreate from './Options/CarOptionsCreate';
import CarContainersCard from './Containers/CarContainersCard';
import CarEquipments from './CarEquipments';
import EditEquipment from '../Equipments/EditEquimpent';
import CarContainerEdit from './Containers/CarContainerEdit';
import CarComplectationsEdit from './Complectations/CarCompectationsEdit';
import CarBuInfo from './CarBuInfo';
import Cars from './Cars';
import { tenant } from '../../brand/tenant';
import isUserHaveRole from '../../utils/isUserHaveRole';
import { ROLE_ADMIN } from '../../constants/roles';

const CarRoutes = () => {
  return (
    <Routes>
      {/* Ð Ð°Ð·Ð´ÐµÐ»ÑÐ½ÑÐµ ÑÐ¿Ð¸ÑÐºÐ¸: ÐÐ¾Ð²ÑÐµ Ð°Ð²ÑÐ¾ / ÐÐ£ Ð°Ð²ÑÐ¾ (ÑÐ¸Ð»ÑÑÑ used Ð½Ð° Ð±ÑÐºÐµ) */}
      <Route
        path="new"
        element={
          // Ð£ Ð±ÑÐ¾ÐºÐµÑÐ° ÑÐ¾Ð»ÑÐºÐ¾ Ñ ÐÐ£-Ð°Ð²ÑÐ¾ (JetQ) ÑÐ°Ð·Ð´ÐµÐ»Ð° Â«ÐÐ¾Ð²ÑÐµ Ð°Ð²ÑÐ¾Â» Ð½ÐµÑ â ÑÑÐ°ÑÐ°Ñ ÑÑÑÐ»ÐºÐ° Ð²ÐµÐ´ÑÑ Ð² Â«ÐÐ£ Ð°Ð²ÑÐ¾Â».
          tenant?.usedCarsOnly ? (
            <Navigate to="/cars/used" replace />
          ) : (
            <Cars key="cars-new" defaultQueryParams={{ used: false }} title="ÐÐ¾Ð²ÑÐµ Ð°Ð²ÑÐ¾" createPath="/cars/new/create" />
          )
        }
      />
      <Route
        path="used"
        element={<Cars key="cars-used" defaultQueryParams={{ used: true }} title="ÐÐ£ Ð°Ð²ÑÐ¾" createPath="/cars/used/create" />}
      />
      <Route element={<CarNavigation />}>
        <Route path="car/:id/main-data" element={<CarMainData />} />
        <Route path="car/:id/equipments" element={<CarEquipments />} />
        <Route path="car/:containerId/equipments/:equipmentId/edit" element={<EditEquipment />} />
        <Route path="car/:id/documents" element={<CarDocs />} />
        <Route path="car/:id/bu-info" element={<CarBuInfo />} />
        <Route path="car/:id/deals" element={<CarDeal />} />
        <Route path="documents" element={<NewCarDocs />} />
        <Route path="deals" element={<NewCarDeal />} />
        <Route path="create" element={<CarCreate />} />
        <Route path="new/create" element={<CarCreate mode="new" />} />
        <Route path="used/create" element={<CarCreate mode="used" />} />
      </Route>
      {/* Ð¡Ð¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ¸ Ð¼Ð°ÑÐ¾Ðº, Ð¼Ð¾Ð´ÐµÐ»ÐµÐ¹ Ð¸ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¹ â ÑÐ¾Ð»ÑÐºÐ¾ Ð°Ð´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾ÑÑ.
          ÐÑÐ°Ð²ÐºÐ° Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ Ð¼Ð°ÑÐºÐ¸ Ð»Ð¾Ð¼Ð°ÐµÑ Ð¸Ð½ÑÐµÐ³ÑÐ°ÑÐ¸Ð¸ Ñ Ð±Ð°Ð½ÐºÐ°Ð¼Ð¸ (Ð»Ð¾Ð³Ð¸Ð½ Ð±Ð°Ð½ÐºÐ° Ð±ÐµÑÑÑÑÑ
          Ð¸Ð· ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ°), Ð° Ð¼Ð°ÑÐ¸Ð½Ñ Ð¾ÑÑÐ°ÑÑÑÑ Ð±ÐµÐ· Ð¼Ð¾Ð´ÐµÐ»Ð¸. ÐÑÑÑÐµÐ¼ Ð½Ðµ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿ÑÐ½ÐºÑ
          Ð¼ÐµÐ½Ñ: Ð¿Ð¾ Ð¿ÑÑÐ¼Ð¾Ð¹ ÑÑÑÐ»ÐºÐµ ÑÑÑÐ°Ð½Ð¸ÑÐ° ÑÐ¾Ð¶Ðµ Ð½Ðµ Ð¾ÑÐºÑÑÐ²Ð°ÐµÑÑÑ. */}
      {isUserHaveRole(ROLE_ADMIN) ? (
        <>
          <Route path="containers" element={<CarContainers />} />
          <Route path="containers/:id" element={<CarContainersCard />} />
          <Route path="containers/:id/edit" element={<CarContainerEdit />} />
          <Route path="containers/create" element={<CarContainersCreate />} />
          <Route path="marks" element={<CarMarks />} />
          <Route path="models" element={<CarModels />} />
          <Route path="marks/create" element={<CarMarksCreate />} />
          <Route path="models/create" element={<CarModelsCreate />} />
          <Route path="complectations" element={<CarComplectations />} />
          <Route path="complectations/:containerId/:complectationId" element={<CarComplectationsEdit />} />
          <Route path="complectations/create" element={<CarComplectationsCreate />} />
          <Route path="options" element={<CarOptions />} />
          <Route path="options/create" element={<CarOptionsCreate />} />
        </>
      ) : (
        <>
          <Route path="containers/*" element={<Navigate to="/cars/new" replace />} />
          <Route path="marks/*" element={<Navigate to="/cars/new" replace />} />
          <Route path="models/*" element={<Navigate to="/cars/new" replace />} />
          <Route path="complectations/*" element={<Navigate to="/cars/new" replace />} />
          <Route path="options/*" element={<Navigate to="/cars/new" replace />} />
        </>
      )}
    </Routes>
  );
};

export default CarRoutes;
